module.exports = __webpack_public_path__ + "4e627cedc4e08f080cf21b6c2d40c93f.pdf";